<template>
  <div>
        <div class="block-content">
        

        <form class="form-horizontal" action="base_forms_premade.html" method="post" onsubmit="return false;">
            <h3 class="font-w300 push-10">{{ sectionLabelCreateDeviceTemplate[actualLanguage] }}</h3>
          
            <div class="form-group">
                <div class="col-xs-12 col-md-12">
                    <label for="register4-firstname">{{ textBoxLabelTemplateId[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="templateId" placeholder="Identifant de gabarit / Template ID">
                </div>

                <div class="col-xs-12 col-md-6">
                    <label for="register4-firstname">{{ textBoxLabelDevicePicture[actualLanguage] }}</label>
                    <!-- ------------------------- 
                    <input class="form-control" type="text" v-model="devicePicture" placeholder="Select">
                    -->
                    <select class="form-control" v-model=devicePicture size="1">
                      <option v-for="picture in pictureList" v-bind:value="picture.fileName">{{picture.pictureReferenceName}}</option>
                    </select>

                </div>

                <div  class="col-xs-12 col-md-6">
                  <div class="form-group">
                    <p><img class = "img-responsive"  width="150px" :src="`organization_img/${devicePicture}` | s3Image"></p>
                  </div>
                </div>




                <div class="col-xs-12 col-md-12">
                    <label for="register4-firstname">{{ textBoxLabelDeviceModel[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="deviceModel" placeholder="Description">
                </div>
                <div class="col-xs-12 col-md-12 push">
                    <label for="register4-firstname">{{ textBoxLabelDeviceName[actualLanguage] }}</label>
                    <input class="form-control" type="text" v-model="deviceName" placeholder="Description">
                </div>

                <div class="col-xs-12 col-md-12 push">
                  <h4 class="font-w300 push-10">{{ labelDataTtlSection[actualLanguage] }}</h4>

                  <div class="col-xs-12 col-md-4">
                      <label for="register4-firstname">{{ labelDataTtlRaw[actualLanguage] }}</label>
                      <input class="form-control" type="text" v-model="dataTTL.raw" placeholder="Description">
                  </div>
                  <div class="col-xs-12 col-md-4">
                      <label for="register4-firstname">{{ labelDataTtlHr[actualLanguage] }}</label>
                      <input class="form-control" type="text" v-model="dataTTL.hr" placeholder="Description">
                  </div>
                  <div class="col-xs-12 col-md-4">
                      <label for="register4-firstname">{{ labelDataTtlDay[actualLanguage] }}</label>
                      <input class="form-control" type="text" v-model="dataTTL.day" placeholder="Description">
                  </div>
                </div>

                <div class="col-sm-12 col-xs-12">
                    <label  for="example-multiple-select">{{ textBoxLabelSignalSet[actualLanguage] }}</label>
                    <select @change="applyNewSignalSet()" class="form-control" v-model=signalSetIndex size="1">
                        <option v-for="(signalSet,indexSignalSet) in signalsSetTemplates" v-bind:value="indexSignalSet">{{signalSet.signalSetId}}</option>
                    </select>
                </div>



            </div>


            <!-- ================================================================= -->
            <!-- Section ajout de variables-->
            <!-- ================================================================= -->
            <div v-if="signalSetIndex >= 0" class="block block-bordered block-themed">
              <div class="form-group">

                
                <div class="col-sm-12">
                  <div class="block-header bg-primary-dark">     
                    <h4 class="font-w300 push-10 text-white-op">{{ textSectionTitleVariables[actualLanguage] }}</h4>
                  </div>
                </div>
                
              
                <div class="block-content">




                <table class="table">
                    <thead>
                        <tr>
                            <th class="text-center" style="width: 15%;">{{ labelVariableVarName[actualLanguage] }}</th>
                            <th class="text-center" style="width: 20%;">{{ labelVariableLabelFR[actualLanguage] }}</th>
                            <th class="text-center" style="width: 20%;">{{ labelVariableLabelEN[actualLanguage] }}</th>
                            <th class="text-center" style="width: 15%;">{{ labelVariableDataFormat[actualLanguage] }}</th>
                            <th class="text-center" style="width: 10%;">{{ labelVariableDataType[actualLanguage] }}</th>
                        </tr>
                    </thead>
                    <tbody>   
                          <tr v-for="(signal,index) in deviceSignals">
                              <td class="text-center">{{ signal.signalName}}</td>
                              <td class="text-center">{{ signal.signalLabel.FR}}</td>
                              <td class="text-center">{{ signal.signalLabel.EN}}</td>
                              <td class="text-center">{{ signal.dataFormat}}</td>
                              <td class="text-center">{{ signal.dataType}}</td>
                          </tr>
                    </tbody>
                </table>



                  <!-- ================================================================= 
                  <div class="form-group">
                    <div class="col-sm-12 col-md-6">
                        <p><button @click="addDeviceSignal()" type="button" class="btn btn-sm btn-success" name="button">
                          <span><i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonAddVariable[actualLanguage] }}</span></button></p>
                    </div>   

                    <div v-if="deviceSignals.length > 0" class="col-sm-12 col-md-6">
                        <p><button @click="deleteDeviceSignal()" type="button" class="btn btn-sm btn-danger" name="button">
                          <span><i class="fa fa-minus fa-1x push-5-r "></i>{{ buttonDeleteVariable[actualLanguage] }}</span></button></p>
                    </div> 
                  </div>
                  -->


                </div>
              </div>
            </div>


            <!-- ================================================================= -->
            <!-- Section ajout de parametres de controle de l'appareil-->
            <!-- ================================================================= -->
            <div v-if="signalSetIndex >= 0" class="block block-bordered block-themed">
              <div class="form-group">

                
                <div class="col-sm-12">
                  <div class="block-header bg-primary-dark">     
                    <h4 class="font-w300 push-10 text-white-op">{{ textSectionTitleControlParameter[actualLanguage] }}</h4>
                  </div>
                </div>
                



                <div class="block-content">
                  <div class="form-group"> 
                    <div class="col-sm-12">
                      <h5 class="font-w300 push-10">{{ textParameterDescription01[actualLanguage] }}</h5>
                      <h5 class="font-w300 push-10">{{ textParameterDescription02[actualLanguage] }}</h5>
                    </div>

                                   
                      <div v-for="(parameter,index3) in controlParameters" class="col-xs-12 col-md-12">

                        <div class="block block-bordered block-themed block-content">
                          <div class="form-group">

                            <div class="col-sm-12 push">
                              <div class="col-sm-12 col-md-6 col-lg-3">
                                <label for="register4-firstname">{{ labelParameterVarName[actualLanguage] }}</label>
                                <h6>{{parameter.parameterName}}</h6>
                              </div>  

                              <div class="col-sm-12 col-md-6 col-lg-3">
                                <label for="register4-firstname">{{ labelParameterLabelFR[actualLanguage] }}</label>
                                <h6>{{parameter.parameterLabel.FR}}</h6>
                              </div>

                              <div class="col-sm-12 col-md-6 col-lg-3">
                                <label for="register4-firstname">{{ labelParameterLabelEN[actualLanguage] }}</label>
                                <h6>{{parameter.parameterLabel.EN}}</h6>
                              </div>

                              <div class="col-sm-12 col-md-6 col-lg-3">
                                <label  for="example-multiple-select">{{ labelParameterDataType[actualLanguage] }}</label>
                                <h6>{{parameter.dataType}}</h6>
                              </div>
                            </div> 

                            <div class="col-sm-12">
                              <div v-if="parameter.dataType==='Bool'" class="col-sm-12 col-md-6 col-lg-3">
                                <div class="col-xs-12">
                                <label for="register4-firstname">{{ labelParameterValue[actualLanguage] }} : On/Off</label>
                                </div>
                                <div class="col-xs-3">
                                  <label class="css-input switch switch-success">
                                      <input type="checkbox" checked v-model="parameter.dataValue"><span></span>
                                  </label>
                                  </div>
                              </div>
                              <div v-else class="col-sm-12 col-md-6 col-lg-3">
                                <label for="register4-firstname">{{ labelParameterValue[actualLanguage] }}</label>
                                <input class="form-control" type="text" v-model="parameter.dataValue" placeholder="Value">
                              </div> 


                              <div class="col-xs-12 col-md-3">
                                <div class="col-xs-12">
                                  <label for="register4-firstname">{{labelParameterFlagVisibleByCustomer[actualLanguage]}}</label>
                                </div>
                                <div class="col-xs-3">
                                  <label class="css-input switch switch-success">
                                      <input type="checkbox" checked v-model="parameter.flagViewByCustomer"><span></span>
                                  </label>
                                </div>
                              </div>

                              <div class="col-xs-12 col-md-3">
                                <div class="col-xs-12">
                                  <label for="register4-firstname">{{labelParameterFlagEditByCustomer[actualLanguage]}}</label>
                                </div>
                                <div class="col-xs-3">
                                  <label class="css-input switch switch-success">
                                      <input type="checkbox" checked v-model="parameter.flagEditByCustomer"><span></span>
                                  </label>
                                </div>
                              </div>
                            </div> 

                          </div>
                        </div>

                      </div>
                  </div>

                  <!-- ================================================================= 
                  <div class="form-group">
                    <div class="col-sm-12 col-md-6">
                        <p><button @click="addDeviceControlParameter()" type="button" class="btn btn-sm btn-success" name="button">
                          <span><i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonAddParameter[actualLanguage] }}</span></button></p>
                    </div>   

                    <div v-if="controlParameters.length > 0" class="col-sm-12 col-md-6">
                        <p><button @click="deleteDeviceControlParameter()" type="button" class="btn btn-sm btn-danger" name="button">
                          <span><i class="fa fa-minus fa-1x push-5-r "></i>{{ buttonDeleteParameter[actualLanguage] }}</span></button></p>
                    </div> 
                  </div>
                  -->


                </div>
              </div>
            </div>

 



            <div class="form-group">
              <div v-if="deviceSignals.length > 0" class="col-sm-12 col-md-12">
                <h4 class="font-w300">{{ labelChannelToCreate[actualLanguage] }}</h4>
                <label  for="example-multiple-select">{{ labelChannelToCreate2[actualLanguage] }}</label>
                <select class="form-control" v-model=channelsToCreate size="3" multiple>
                      <option v-for="template in compatibleChannelTemplateList" v-bind:value="template.channelTemplateId">{{template.channelName}}</option>
                </select>
              </div>
            </div>



            <div class="form-group">
              <div v-if="channelsToCreate.length > 0" class="col-sm-12 col-md-12">

                <div class="col-sm-12 col-md-12 col-lg-12 push">
                  <label for="register4-firstname">{{ labelSelectApiKey[actualLanguage] }} </label>
                  <select class="form-control" v-model=selectedApiKey size="1">
                      <option v-for="key in overlayParameters.organizationApiKeys" v-bind:value="key.key">{{key.referenceName}} : {{key.key}}</option>
                  </select>

                </div>


                <div v-if="selectedApiKey.length > 0">
                    <p><button @click="saveDeviceTemplate()" type="button" class="btn btn-block btn-success" name="button">
                      <spinner size="small" v-if="templateIsCreating"></spinner>
                      <span v-else><i class="fa fa-plus fa-1x push-5-r "></i>{{ buttonLabelSave[actualLanguage] }}</span></button></p>
                </div> 
              </div>
            </div>



          </form>
        </div>

  </div>
</template>

<script>

import {mapState, mapActions} from 'vuex'
import Spinner from '../../components/Spinner.vue'
import _ from 'underscore'
export default {
  name: 'AddDeviceTemplateForm',
  components: {
    Spinner
  },
  data() {
    return {
      errorMsg: '',
      templateIsCreating: false,
      actualLanguage : "FR",

      sectionLabelCreateDeviceTemplate:{FR: "Gabarit d'appareil de mesure", EN: 'Measurement device templates'},

      textBoxLabelTemplateId:{FR: "Identifiant du gabarit d'appareil de mesure", EN: 'Measurement device templates ID'},
      templateId : "",

      //textBoxLabelChannelName:{FR: "Identifiant de l'appareil (channel)", EN: 'Device identifier'},
      //channelName : "",

      textBoxLabelDevicePicture:{FR: "Image d'appareil", EN: 'Device picture'},
      devicePicture : "",
      pictureList : [],
      
      textBoxLabelDeviceModel:{FR: "Modèle d'appareil", EN: 'Device model'},
      deviceModel : "",

      //textBoxLabelChannelDescription:{FR: "Description d'appareil", EN: 'Device description'},
      //channelDescription : "",

      textBoxLabelDeviceName:{FR: "Nom d'appareil", EN: 'Device name'},
      deviceName : "",

      textSectionTitleVariables:{FR: "Signaux de l'appareil (définis par l'ensemble sélectionné)", EN: "Device signals (define by signal set)"},

      textBoxLabelSignalSet:{FR: "Ensemble de signaux", EN: 'Signal set'},
      signalsSetTemplates : [],
      signalSetIndex : -1,

      deviceSignals : [],
      labelVariableLabelFR:{FR: "Étiquette (FR)", EN: "Label (FR)"},
      labelVariableLabelEN:{FR: "Étiquette (EN)", EN: "Label (EN)"},
      labelVariableVarName:{FR: "Signal (variable)", EN: "Signal (variable)"},

      labelVariableDataFormat:{FR: "Format", EN: "Format"},
      labelVariableDataType:{FR: "Type", EN: "Type"},

      buttonAddVariable:{FR: "Ajouter une variable", EN: 'Add variable'},
      buttonDeleteVariable:{FR: "Supprimer dernière variable", EN: 'Deleta last variable'},

      labelDataTtlSection :{FR: "Durée de vie des données (jours)", EN: 'Data life time (days)'},
      labelDataTtlRaw :{FR: "Données brutes (RAW)", EN: 'RAW data'},
      labelDataTtlHr :{FR: "Données agrégées aux heures", EN: 'Agregated hourly data'},
      labelDataTtlDay :{FR: "Données agrégées aux journées", EN: 'Agregated daily data'},
      dataTTL : {raw:'365',hr:'365',day:'730'},




      controlParameters : [],
      textSectionTitleControlParameter:{FR: "Parametre de control de l'appareil de mesure",
                                        EN: "Control parameters of the measurement device"},
      textParameterDescription01:{FR: "Les paramètres de contrôle permettent de modifier un état de l'appareil en cours de fonctionnement.",
                                        EN: "The control parameters make it possible to modify a state ot the device during operation"},
      textParameterDescription02:{FR: "Une nouvelle valeur est modifiable via la page de configuration de l'appareil et transmise à l'appareil lors que ce dernier communique des mesures au cloud EV Sens.",
                                        EN: "A new value can be modified via the device configuration page and transmitted to the device when the latter communicates measurements to the EV Sens cloud"},

      labelParameterLabelFR:{FR: "Étiquette (FR)", EN: "Label (FR)"},
      labelParameterLabelEN:{FR: "Étiquette (EN)", EN: "Label (EN)"},
      labelParameterVarName:{FR: "Nom variable programme", EN: "Program variable name"},
      labelParameterDataType:{FR: "Type de donnée", EN: "Data type"},
      labelParameterValue:{FR: "Valeur", EN: "Value"},
      labelParameterFlagVisibleByCustomer:{FR: "Visible par client", EN: "Visible by customer"}, 
      labelParameterFlagEditByCustomer:{FR: "Modifiable par client", EN: "Editable by customer"}, 
      labelParameter:{FR: "", EN: ""}, 
  
      buttonAddParameter:{FR: "Ajouter un parametre", EN: 'Add parameter'},
      buttonDeleteParameter:{FR: "Supprimer dernière parametre", EN: 'Deleta last parameter'},


      labelChannelToCreate :{FR: "Appareils mesurés qui seront créés lors de l'enregistrement au profil client", EN: 'Measured device(s) created when customer bind the measurement device'},
      labelChannelToCreate2 :{FR: "Sélection multiple possible (maintenir la touche CTRL pour sélection multiple)", EN: 'Multiple selection is possible (maintain CTRL key for multiple selection)'},
      channelTemplateList : [],
      compatibleChannelTemplateList : [],
      channelsToCreate : [],

      selectedApiKey : "",

      buttonLabelSave:{FR: "Créer/Modifier le gabarit", EN: 'Create/Modify the template'},

      labelSelectApiKey:{FR: "Cette action requiert une clef d'API maître, vous devez en sélectionné une:", EN: 'This action require a master API key, select one:'},
      messageProfileRefreshAction:{FR: "Le gabarit a été créé dans le système, cette opération requiert un rafraichissement des données de votre organisation (fait automatiquement).",
                                   EN: 'The template was created in the system, this action require an organization data refresh (done automatically).'},

    }
  },


  methods: {

    applyNewSignalSet(){
      this.deviceSignals = this.signalsSetTemplates[this.signalSetIndex].deviceSignals
      this.controlParameters = this.signalsSetTemplates[this.signalSetIndex].controlParameters

      //We have to create the list of channel compatible with the actual selected signalSet
      this.compatibleChannelTemplateList = []
      for (var n = 0; n < this.channelTemplateList.length; n++){
        if(this.channelTemplateList[n].signalSetId==this.signalsSetTemplates[this.signalSetIndex].signalSetId)
        this.compatibleChannelTemplateList.push(this.channelTemplateList[n])
      }

    },


    addDeviceSignal(){
      this.deviceSignals.push({
        signalLabel:{FR:"",EN:""},
        signalName:"",
        dataFormat :"",
        dataType:""
      })
    },
    deleteDeviceSignal(){
      this.deviceSignals.pop()
    },


    addDeviceControlParameter(){
      this.controlParameters.push({
        parameterLabel:{FR:"",EN:""},
        parameterName:"",
        dataType:"",
        dataValue:"",
        dataValueLastTransmit:"999999999999",
        flagViewByCustomer:false,
        flagEditByCustomer:false,
      })
    },
    deleteDeviceControlParameter(){
      this.controlParameters.pop()
    },

    changeDataType(index){
      if(this.controlParameters[index].dataType=='Numeric'){this.controlParameters[index].dataValue='0'}
      if(this.controlParameters[index].dataType=='Bool'){this.controlParameters[index].dataValue=false}
    },

    saveDeviceTemplate() {
      var ValidationFlag = true
      if(this.templateId.length==0){
        var ErrorMessage = {FR:"L'identifiant de gabarit est vide!",EN:"The template ID is empty!"}
        window.alert(ErrorMessage[this.actualLanguage])
        ValidationFlag = false
      }

      if (ValidationFlag){
          var postBody = {
            'postAction':'createDeviceTemplate',
            'postSubAction':this.overlayParameters.action,
            'organization_id':this.overlayParameters.organizationId.substring(5,20),
            'template_id':this.templateId,
            'evsTemplate':'ApiDevice_V1P00',
            'devicePicture':this.devicePicture,
            'deviceModel':this.deviceModel,
            'deviceName':this.deviceName,
            'signalSetId':this.signalsSetTemplates[this.signalSetIndex].signalSetId,
            'deviceSignals':this.deviceSignals,
            'controlParameters':this.controlParameters,
            'dataTTL':this.dataTTL,
            'channelToCreates':this.channelsToCreate
          }

          var requestData = { 'postAction':'ApiCustomerGateway',
                              'organizationId': this.overlayParameters.organizationId,
                              'organizationApiKey': this.selectedApiKey,
                              'postBody':postBody ,
                            }

          this.templateIsCreating = true
          this.$store.dispatch('sessionStore/postOrganization', requestData)
              .then((response) => {
                //console.log('--------------------------')
                //console.log(response.data)
                this.templateIsCreating  = false
              if(response.data.Code=='OK'){
                  window.alert(this.messageProfileRefreshAction[this.actualLanguage])
                  this.$store.dispatch('sessionStore/refreshProfileData')
                  this.$store.dispatch('overlayStore/toggleModal',false)
                  }
                  else{ window.alert(response.data.CallResponse.message)}
              })
      }      
      
      
      
      },


    getDeviceTemplate(){
      this.channelTemplates = []
        var requestData = { 'postAction':'GetOrganizationSingleDeviceTemplate',
                            'organizationId': this.overlayParameters.organizationId,
                            'templateId': this.overlayParameters.templateId,
                          }

        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
              //console.log('----Get Channel Template-----')
              //console.log(response.data)
              
            if(response.data.Code=='OK'){
                this.templateId = this.overlayParameters.templateId
                this.deviceName = response.data.DeviceTemplate.deviceName
                this.deviceModel = response.data.DeviceTemplate.deviceModel
                this.devicePicture = response.data.DeviceTemplate.devicePicture
                this.deviceSignals = response.data.DeviceTemplate.deviceSignals
                this.controlParameters=response.data.DeviceTemplate.controlParameters
                this.dataTTL = response.data.DeviceTemplate.dataTTL
                this.channelsToCreate = response.data.DeviceTemplate.channelsToCreate

                //We have to identify the index of the signalSetId into the loaded signalsSetsList
                //console.log("signalSet ID:")
                //console.log(response.data.ChannelTemplate.signalSetId)
                for (var n = 0; n < this.signalsSetTemplates.length; n++){
                  if(this.signalsSetTemplates[n].signalSetId == response.data.DeviceTemplate.signalSetId){
                    this.signalSetIndex = n
                    }
                }

                //We have to create the list of channel compatible with the actual selected signalSet
                this.compatibleChannelTemplateList = []
                for (var n = 0; n < this.channelTemplateList.length; n++){
                  if(this.channelTemplateList[n].signalSetId==this.signalsSetTemplates[this.signalSetIndex].signalSetId)
                  this.compatibleChannelTemplateList.push(this.channelTemplateList[n])
                }

                }
                else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
            })  

    },

    getSignalSetList(){
      this.channelTemplates = []
        var requestData = { 'postAction':'GetOrganizationSignalsSet',
                            'organizationId': this.overlayParameters.organizationId,
                          }

        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
              
            if(response.data.Code=='OK'){
                //this.createNewApiMasterKey = false
                this.signalsSetTemplates = response.data.SignalsSets

                if (this.overlayParameters.action == 'edit'){
                    this.getDeviceTemplate()
                }

                }
                else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
            })  
    },

    getChannelTemplateList(){
      this.pictureList = []
        var requestData = { 'postAction':'GetOrganizationChannelTemplates',
                            'organizationId': this.overlayParameters.organizationId,
                          }

        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                this.channelTemplateList = response.data.ChannelTemplates
                }
                else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
            })  
    },

    getPictureList(){
      this.pictureList = []
        var requestData = { 'postAction':'GetOrganizationPictureList',
                            'organizationId': this.overlayParameters.organizationId,
                            'pictureType': 'device',
                          }

        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                this.pictureList = response.data.PictureList
                }
                else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
            })  
    },


  
  },

  computed: {
    ...mapState('sessionStore', ['profileData']),
    ...mapState('overlayStore', ['overlayParameters']),
  },

  mounted() {
    
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}

    //console.log('-----Profile Data----')
    //console.log(this.profileData)
    this.getPictureList()
    this.getChannelTemplateList()
    this.getSignalSetList() //This function call this.getDeviceTemplate() if the this.overlayParameters.action == 'edit'


  }


}
</script>



// WEBPACK FOOTER //
// OrganizationApiDeviceTemplateAddForm.vue?613b6619